export default __webpack_public_path__ + "static/img3@2x-70d42ba4b189975608dea5752432176f.jpg";